import jsPDF from 'jspdf';
import LogoBase16 from "../Birdsafe_App_Logo_4";
import { DaytimeRating, NighttimeRating } from "./Algorithm";

const getImageDimensions = src => {
  return new Promise (function (resolved, rejected) {
    var img = new Image();
    img.onload = function(){
      resolved({width: img.width, height: img.height});
    };
    img.src = src;
  })
};

const addHeader = (doc, y, marginTop = 10, marginBottom = 0, marginLeft = 15) => {
  const width = 1339/7.5; // widthInPixels / empericalScalingFactor
  const height = 196/7.5; // heightInPixels / empericalScalingFactor
  // looks like the image (x,y) is from top left
  doc.addImage(LogoBase16, 'JPEG', marginLeft, marginTop, width, height);
  y.val = marginTop + height + marginBottom;
};

// This isn't quite right... Bigger text appears too low...
const write = (doc, size, text, y, marginTop = 0, marginBottom = 0, marginLeft = 15) => {
  y.val += marginTop;
  const empericalFontSizeFactor = 2.2;
  const heightOfText = size / empericalFontSizeFactor;
  y.val += heightOfText;
  doc.setFontSize(size);
  // looks like the text (x,y) is from bottom left
  doc.text(marginLeft, y.val, text);
  y.val += marginBottom;
};

const fillWithImage = async (doc, imageBase64, y, marginTop = 5, marginBottom = 15, marginLeft = 15) => {
  const dims = await getImageDimensions(imageBase64);
  const aspectRatio = dims.height / dims.width;
  const maxWidth = 180; // doc.internal.pageSize.getWidth() - marginLeft - marginRight; <- marginRight = marginLeft
  const correspondingHeight = maxWidth * aspectRatio;
  const maxHeight = 280 - y.val; // doc.internal.pageSize.getHeight() - y.val - marginTop - marginBottom;
  const correspondingWidth = maxHeight / aspectRatio;
  const [ width, height ] =
    correspondingHeight < maxHeight
    ? [ maxWidth, correspondingHeight ]
    : [ correspondingWidth, maxHeight ];

  y.val += marginTop;
  // looks like the image (x,y) is from top left
  doc.addImage(imageBase64, 'JPEG', 15, y.val, width, height);
  // don't really need to update y because nothing else will be added to the page anyway
  y.val += height;
  y.val += marginBottom;
};

export default async (building, lang) => {
  const Lang = lang.generate;
  if(!building || !building.facades) {
    console.error("can't find building to generate report for");
    return;
  }

  let doc = new jsPDF();
  let y = {
    val: 0
  };
  let numPages = 1;
  addHeader(doc, y);
  write(doc, 40, Lang.report_header, y, -5, 5);
  doc.setFontSize(10);
  write(doc, 10, Lang.report_generated_for, y);
  write(doc, 20, building.buildingId, y); // can I make this bold? add some marginBottom...

  for(const facade of building.facades) {
    write(doc, 15, Lang.facade_colon + facade.facadeId, y);
    write(doc, 12, DaytimeRating(building, facade, lang), y);
    write(doc, 12, NighttimeRating(building, facade, lang), y);
    if(facade.imageSrc) {
      await fillWithImage(doc, facade.imageSrc, y);
    }
    doc.addPage(); y.val = 0; addHeader(doc, y); numPages++;
  }
  // I guess they index pages from 1
  doc.deletePage(numPages); numPages--; // clean up extra page from last iteration

  doc.save(Lang.report_header + ".pdf"); // include name of builing? (could cause issues...)
};


// WEBPACK FOOTER //
// ./src/modules/GeneratePDF.js